/* src/components/progress-bar/progress-bar.component.scss */
@keyframes border-blink {
  from {
    border: 1px solid rgba(0, 140, 188, 0);
  }
  50% {
    border: 1px solid rgb(0, 140, 188);
  }
  to {
    border: 1px solid rgba(0, 140, 188, 0);
  }
}
:host {
  display: block;
  position: relative;
  height: 2px;
  border-radius: 2px;
  background-color: var(--vwui-color-neutral-4);
}
:host .current-progress {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: var(--vwui-color-primary);
  width: 0;
  border-radius: 6px;
  height: 100%;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
:host .step {
  position: absolute;
  z-index: 2;
  top: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  font-weight: bold;
  margin: -12px;
  border-radius: 12px;
  text-align: center;
  background: #fff;
  border: 1px solid var(--vwui-color-neutral-2);
  color: rgba(255, 255, 255, 0);
  box-shadow: var(--vwui-shadow-base), 0 0 0 3px #fff;
  -webkit-user-select: none;
  user-select: none;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
:host .step__tooltip,
:host .step__text {
  width: 34px;
  height: 34px;
  line-height: 34px;
}
:host .step__blink {
  position: absolute;
  width: 38px;
  height: 38px;
  line-height: 38px;
  border-radius: 50%;
  top: -2px;
  left: -2px;
  animation: border-blink 2s;
  animation-iteration-count: 4;
}
:host .step__tooltip {
  position: absolute;
  top: -5px;
  left: -6px;
  display: block;
  border-radius: 50%;
}
:host .step:hover,
:host .step:focus {
  outline: none;
  box-shadow: var(--vwui--shadow--focus), 0 0 0 3px #fff;
}
:host .step--active {
  background-color: var(--vwui-color-primary);
  border-color: var(--vwui-color-primary);
  color: #fff;
}
:host .step--active:hover,
:host .step--active:focus {
  box-shadow: var(--vwui--shadow--focus), 0 0 0 3px #fff;
}
/*# sourceMappingURL=progress-bar.component-G73JJT5R.css.map */
